import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { Button } from "@progress/kendo-react-buttons";
import { Localization } from "../../common/Localization";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { PotvrdenieStavEnum } from "../../../enums";
import confirmService from "../../common/confirmService";
import { MessageTypeEnum, TypTovaru } from "../../../enums";
import { Input } from "@progress/kendo-react-inputs";
import { nahlasenieDodavkyController } from "../../../controllers/nahlaseniedodavky.controller";
import Moment from "moment";

class NahlasenieKusyDialogContent extends Component {
    state = {
        dialog: {
            title: null,
            content: null,
            width: null,
            height: null
        }
    };

    constructor(props) {
        super(props);
        this.dodavka = this.props.dodavka;
        this.baliky = this.getBaliky(this.dodavka.poleBAL);
        this.rozdiely = this.getRozdiely(this.dodavka.poleBAL);
    }

    getBaliky(baliky) {
        var i = 1;
        baliky = baliky.filter(item => {
            item.id = i++;
            item.packing = this.getPackingText(item.packing);
            item.rozdielKsText = item.potvrdenieStavKs === PotvrdenieStavEnum.NIC ? "" : item.rozdielKs;
            item.skutKsText = item.potvrdenieStavKs === PotvrdenieStavEnum.NIC ? "" : item.rozdielKs + item.pocetKs;
            item.potvrdenieStavKsText = this.getStavText(item.potvrdenieStavKs);
            return item.potvrdenieStavBAL === PotvrdenieStavEnum.OK || item.potvrdenieStavBAL === PotvrdenieStavEnum.NAVIAC;
        });
        return baliky;
    }

    getStavText(stav) {
        switch (stav) {
            case PotvrdenieStavEnum.NIC:
                return "";
            case PotvrdenieStavEnum.OK:
                return "OK";
            case PotvrdenieStavEnum.CHYBA:
                return "CHÝBA";
            case PotvrdenieStavEnum.NAVIAC:
                return "NAVIAC";
            case PotvrdenieStavEnum.ROZDIEL:
                return "ROZDIEL";
            case PotvrdenieStavEnum.ZAMENA:
                return "ZÁMENA";
            default:
                return "???";
        }
    }

    getPackingText(packing) {
        if (packing.length === 13 && packing.substring(0, 1) === "8") {
            debugger;
            if (packing.substring(10, 2) === "08") {
                // nové číslování balíků pro packing (na pozici 11-12 EAN je 08)
                packing = packing.substring(1, 9); // délka je 9 a začíná znaky 0
                packing = packing.replace(/^0+/, ""); // ořezat znaky 0 na začátku
            } else {
                // původní číslování pro packing
                packing = packing.substring(1, packing.substring(8, 1) === "0" ? 7 : 8);
            }
        }
        return packing;
    }

    getRozdiely(baliky) {
        baliky = baliky.filter(item => {
            return item.potvrdenieStavBAL === PotvrdenieStavEnum.OK || item.potvrdenieStavBAL === PotvrdenieStavEnum.NAVIAC;
        });
        var rozdielyArr = [];
        baliky.forEach(item => {
            for (var i = 0; i < item.poleNAHL.length; i++) {
                var rozdiel = {
                    id: item.poleNAHL[i].id,
                    packing: i === 0 ? this.getPackingText(item.packing) : "",
                    textArtikel: item.poleNAHL[i].textArtikel,
                    pocetKs: item.poleNAHL[i].pocetKs
                };
                rozdielyArr.push(rozdiel);
            }
        });
        return rozdielyArr;
    }

    nahlasitDodavku = () => {
        this.setState({
            nahlasitDodavkuDisabled: true
        });
        nahlasenieDodavkyController.ulozitANahlasitKusy(this.dodavka).then(async response => {
            if (response.isError) {
                await confirmService.show({
                    type: MessageTypeEnum.EXCLAMATION,
                    message: response.errorMessage,
                    logMessage: true
                });
            } else {
                this.props.reloadSpravyGrid();
                this.props.reloadNahlasNenahlasDodavkyGrid();
            }
            this.setState({
                nahlasitDodavkuDisabled: false
            });
            this.props.toggleDialog();
        });
    };

    zistitBalikovLotovPreKusoveNahlasenie() {
        var localizationService = provideLocalizationService(this);

        var balikov = 0;
        var lotov = 0;

        this.dodavka.poleBAL.forEach(item => {
            if (item.potvrdenieStavBAL !== PotvrdenieStavEnum.CHYBA) {
                if (item.packing.length === 8) {
                    ++balikov;
                } else {
                    ++lotov;
                }
            }
        });
        var balikovText = balikov === 0 ? "" : `${balikov} ${localizationService.toLanguageString("Nahl.balíkov", "balíkov")}`;
        var lotovText = lotov === 0 ? "" : `${lotov} ${localizationService.toLanguageString("Nahl.lotov", "lotov")}`;
        return `${balikovText} ${balikov !== 0 && lotov !== 0 ? "+" : ""} ${lotovText}`;
    }

    render() {
        var localizationService = provideLocalizationService(this);
        return (
            <div id="NahlasenieDodavkyKusy">
                <div className="alert alert-info nadpis">
                    {this.dodavka.typTovaru == TypTovaru.R
                        ? "HS Ružomberok"
                        : this.dodavka.typTovaru == TypTovaru.S
                        ? "HS Sereď"
                        : this.dodavka.jeToDachser
                        ? "DACHSER"
                        : "GEIS"}{" "}
                    - {localizationService.toLanguageString("NahlKsFRM.NAHLÁSENIE KUSOV pre", "NAHLÁSENIE KUSOV pre")}{" "}
                    {this.zistitBalikovLotovPreKusoveNahlasenie()}
                </div>
                <div className="col-sm-6">
                    <Grid style={{ height: "462px" }} data={this.baliky}>
                        <GridColumn field="packing" title={localizationService.toLanguageString("NahlKsFRM.Grid.Položka", "Položka")} />
                        <GridColumn field="typTovaru" title={localizationService.toLanguageString("NahlKsFRM.Grid.Typ", "Typ")} width="70px" />
                        <GridColumn field="pocetKs" title={localizationService.toLanguageString("NahlKsFRM.Grid.Ks", "Ks")} />
                        <GridColumn field="potvrdenieStavKsText" title={localizationService.toLanguageString("NahlKsFRM.Grid.Stav", "Stav")} />
                        <GridColumn field="rozdielKsText" title={localizationService.toLanguageString("NahlKsFRM.Grid.Rozdiel", "Rozdiel")} />
                        <GridColumn field="skutKsText" title={localizationService.toLanguageString("NahlKsFRM.Grid.Skut.ks", "Skut.ks")} />
                    </Grid>
                </div>
                <div className="col-sm-6">
                    <Grid style={{ height: "232px" }} data={this.rozdiely}>
                        <GridColumn field="packing" title={localizationService.toLanguageString("NahlKsFRM.Grid.Položka", "Položka")} />
                        <GridColumn field="textArtikel" title={localizationService.toLanguageString("NahlKsFRM.Grid.Zistené rozdiely", "Zistené rozdiely")} />
                        <GridColumn field="pocetKs" title={localizationService.toLanguageString("NahlKsFRM.Grid.Rozdiel ks", "Rozdiel ks")} width="70px" />
                    </Grid>
                    <div className="k-form">
                        <div className="row" style={{ marginTop: "10px" }}>
                            <div className="col-xs-6">
                                <div className="k-form-field">
                                    <span>{localizationService.toLanguageString("NahlKsFRM.Počet ks", "Počet ks")}</span>
                                    <Input value={this.dodavka.pocetKs} disabled />
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <div className="k-form-field">
                                    <span>{localizationService.toLanguageString("NahlKsFRM.Rozdiel ks", "Rozdiel ks")}</span>
                                    <Input value={this.dodavka.rozdielKs} disabled />
                                </div>
                            </div>
                            <div className="col-xs-offset-6 col-xs-6">
                                <div className="k-form-field">
                                    <span>{localizationService.toLanguageString("NahlKsFRM.Skutočný počet ks", "Skutočný počet ks")}</span>
                                    <Input value={this.dodavka.pocetKs + this.dodavka.rozdielKs} disabled />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-offset-6 col-xs-6">
                                <span>
                                    {localizationService.toLanguageString("NahlKsFRM.Dátum a čas vyloženia na predajňu", "Dátum a čas vyloženia na predajňu")}
                                </span>
                                <div className="k-form-field">
                                    <Input value={Moment(this.dodavka.datumVylozeniaTovaru).format("D.M.YYYY H:mm:ss") || ""} disabled />
                                </div>
                            </div>
                        </div>
                        {!this.props.readOnly && (
                            <div className="row" style={{ paddingTop: "20px" }}>
                                <div className="col-xs-offset-6 col-xs-6 text-right">
                                    <Button onClick={this.nahlasitDodavku} disabled={this.state.nahlasitDodavkuDisabled} className="font-bold">
                                        <Localization messageKey={"NahlKsFRM.Uložiť a odoslať"} defaultMessage={"Uložiť a odoslať"} />
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default NahlasenieKusyDialogContent;

registerForLocalization(NahlasenieKusyDialogContent);



// WEBPACK FOOTER //
// ./src/components/dialogs/RucniNahlasenieDodavky/NahlasenieKusyDialogContent.js